import type { FC } from 'react';
import React from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TEmail } from './models';

/**
 * Поле ввода email
 * memo требуется для того чтоб избежать лишнего
 * ререндера при сабмите, при котором Final Form сбрасывает значения
 * meta.touched, из-за чего пропадают галочки напротив
 * корректно заполненных полей
 */
export const Email: FC<TEmail> = React.memo(
    ({
        EmailField,
        Field,
        className,
        getCaption,
        hideStatusIcon,
        isError,
        isSuccess,
        name,
        optional,
        settings,
        validateEmail,
    }) => (
        <Field
            data={settings}
            dispatchesFocus
            name={name}
            receivesFocus
            render={({ input, meta }) => (
                <div className={className}>
                    <EmailField
                        {...input}
                        arrow={false}
                        caption={getCaption(meta, settings.caption)}
                        dataTestId={settings.dataTestId}
                        error={isError(meta)}
                        forwardedRef={actions.getRef(meta)}
                        hideStatusIcon={hideStatusIcon}
                        onBlur={actions.onBlur(input)}
                        onCancel={actions.onCancel({ input, meta })}
                        onChange={({ value }) => actions.onChange(input)(String(value))}
                        onFocus={actions.onFocus(input)}
                        onSelect={({ value }) => actions.onSelect({ input, meta })(value)}
                        placeholder={settings.placeholder}
                        success={isSuccess({ input, meta })}
                    />
                </div>
            )}
            validate={validateEmail(optional)}
        />
    )
);
